(function() {
  /**
   * Artie Recipe Card Toggle Logic
   * Handles expanding/collapsing recipe details.
   */
  if (customElements.get('artie-recipe-card')) return;

  class ArtieRecipeCard extends HTMLElement {
    constructor() {
      super();
      this._boundToggle = this.toggleDetails.bind(this);
      this._handleBlockSelect = this.handleBlockSelect.bind(this);
      this._handleBlockDeselect = this.handleBlockDeselect.bind(this);
    }

    connectedCallback() {
      // Delay initialization to ensure children are parsed (handles race condition)
      setTimeout(() => this.init(), 0);
    }

    init() {
      if (this.initialized) return;

      this.toggleBtn = this.querySelector('[data-recipe-toggle]');
      this.toggleText = this.querySelector('[data-recipe-toggle-text]');
      
      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', this._boundToggle);
        
        // Theme Editor Events
        this.addEventListener('shopify:block:select', this._handleBlockSelect);
        this.addEventListener('shopify:block:deselect', this._handleBlockDeselect);

        this.initialized = true;
      }
    }

    toggleDetails(e) {
      if (e) e.preventDefault();
      const isExpanded = this.getAttribute('data-expanded') === 'true';
      if (!isExpanded) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.setAttribute('data-expanded', 'true');
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', 'true');
      this._updateText(true);
    }

    close() {
      this.setAttribute('data-expanded', 'false');
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', 'false');
      this._updateText(false);
    }

    _updateText(isExpanded) {
      if (!this.toggleText) return;
      const newText = isExpanded 
        ? this.toggleText.getAttribute('data-text-hide') 
        : this.toggleText.getAttribute('data-text-view');
      this.toggleText.textContent = newText;
    }

    handleBlockSelect() {
      this.open();
    }

    handleBlockDeselect() {
      this.close();
    }
  }

  customElements.define('artie-recipe-card', ArtieRecipeCard);
})();
